import { ApiSessionProbe } from "../ApiSessionProbe";

export function AgentHome() {
  return (
    <div>
      <p className="sdw-kicker">Agent workspace</p>
      <h1 className="sdw-h1">Welcome</h1>
      <p className="sdw-lead">
        This shell is for campaign operators and agents (Wildix-linked identity). Layout and tone differ from platform
        admin on purpose.
      </p>
      <div className="sdw-card" style={{ marginBottom: "1.25rem" }}>
        <strong>Next:</strong> campaign queue, lead context, and Collaboration screen-pop — see Implementation Plan
        Phase 2–3.
      </div>
      <ApiSessionProbe variant="agent" />
    </div>
  );
}
